export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ExteriorIcon.776d80a3.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};